import { ReactNode } from 'react';
import { useReveal } from '../../hooks/useReveal';

interface SectionProps {
  id?: string;
  className?: string;
  children: ReactNode;
  bgImage?: string;
  overlayOpacity?: number;
}

export default function Section({ 
  id, 
  className = "bg-gradient-to-b from-gray-900 to-black", 
  children,
  bgImage,
  overlayOpacity = 0.1
}: SectionProps) {
  const { isVisible, ref } = useReveal(0.1);

  return (
    <section 
      id={id}
      ref={ref as any}
      className={`py-20 relative overflow-hidden ${className}`}
    >
      {bgImage && (
        <div className="absolute inset-0 pointer-events-none">
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{ 
              backgroundImage: `url('${bgImage}')`,
              opacity: overlayOpacity 
            }}
          />
          <div className={`absolute inset-0 ${className.includes('from-') ? '' : 'bg-black/60'}`} />
        </div>
      )}
      
      <div className={`max-w-7xl mx-auto px-6 lg:px-8 relative z-10 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}>
        {children}
      </div>
    </section>
  );
}